import { DEFAULT_ACCESS_RIGHTS } from '../app.constants';

export class AccessService {
    constructor() {}

    profileRights = DEFAULT_ACCESS_RIGHTS;

    checkAccess(profileRights) {
        profileRights.forEach(item => {
            // доступ к изменению статуса урока
            if (+item.index_title === this.profileRights.change_status_other_lesson.index_title) {
                this.profileRights.change_status_other_lesson.is_access = true;
            }

            // доступ к копированию чужих уроков
            if (+item.index_title === this.profileRights.copy_other_lesson.index_title) {
                this.profileRights.copy_other_lesson.is_access = true;
            }

            // доступ к созданию урока
            if (+item.index_title === this.profileRights.create_lesson.index_title) {
                this.profileRights.create_lesson.is_access = true;
            }

            // доступ к удалению чужого урока
            if (+item.index_title === this.profileRights.delete_other_lesson.index_title) {
                this.profileRights.delete_other_lesson.is_access = true;
            }

            // доступ к редактированию чужого урока
            if (+item.index_title === this.profileRights.edit_other_lesson.index_title) {
                this.profileRights.edit_other_lesson.is_access = true;
            }

            // доступ к редактированию шаблонов
            if (+item.index_title === this.profileRights.edit_templates.index_title) {
                this.profileRights.edit_templates.is_access = true;
            }

            // доступ к копированию шаблонов
            if (+item.index_title === this.profileRights.copy_templates.index_title) {
                this.profileRights.copy_templates.is_access = true;
            }

            // доступ к удалению шаблонов
            if (+item.index_title === this.profileRights.delete_templates.index_title) {
                this.profileRights.delete_templates.is_access = true;
            }

            // доступ к отчетам доступных школ
            if (+item.index_title === this.profileRights.access_for_reports.index_title) {
                this.profileRights.access_for_reports.is_access = true;
            }
        });

        return this.profileRights;
    }
}
